import { apiClient } from './axios';

import type { LeadWithRelations, LeadQuery, PaginatedResponse } from '@repo/shared-types';

export const leadsApi = {
  getLeads: async (query?: Partial<LeadQuery>): Promise<PaginatedResponse<LeadWithRelations>> => {
    const response = await apiClient.get<PaginatedResponse<LeadWithRelations>>('/leads', {
      params: query,
    });
    return response.data;
  },

  getLead: async (id: string) => {
    const response = await apiClient.get<LeadWithRelations>(`/leads/${id}`);
    return response.data;
  },
};
